function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.333 24c-1.466 0-2.653 1.2-2.653 2.667 0 1.466 1.187 2.666 2.653 2.666 1.467 0 2.667-1.2 2.667-2.666C12 25.2 10.8 24 9.333 24zm-8-21.333v2.666H4l4.8 10.12L7 18.72c-.213.373-.333.813-.333 1.28 0 1.467 1.2 2.667 2.666 2.667h16V20H9.893c-.186 0-.333-.147-.333-.333l.04-.16 1.2-2.174h9.933c1 0 1.88-.546 2.334-1.373l4.773-8.653c.107-.187.16-.414.16-.64 0-.734-.6-1.334-1.333-1.334H6.947L5.693 2.667h-4.36zM22.667 24c-1.467 0-2.654 1.2-2.654 2.667 0 1.466 1.187 2.666 2.654 2.666 1.466 0 2.666-1.2 2.666-2.666 0-1.467-1.2-2.667-2.666-2.667z",
  transform: "translate(-1143 -2195) translate(1123 2175) translate(20 20)"
})))));

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.f5b7550a.svg";
export { ForwardRef as ReactComponent };